import { z } from "zod";

import { padStringDirectionSchema } from "./enums";

export const padStringConfigurationSchema = z.object({
	sourceField: z.string(),
	targetField: z.string(),
	length: z.number(),
	paddingCharacter: z.string(),
	padStringDirection: padStringDirectionSchema,
});
